// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"Login_errorMessage__xwfSZ","socialButtons":"Login_socialButtons__29tcs","icon":"Login_icon__nNNPb"};